<script lang="ts">
    import s from './style.module.css';

    export let handleClick: () => void;
    export let marginBottom = '';
    export let marginTop = '';
    export let lineHeight = '20px';
    export let color: 'gray' | 'light' | 'dark' | 'blue' | 'nevada' | 'nevadaCold' | 'dodgerBlue' =
        'light';
    export let children: any;
    export let template = 'circle';
    export let fontSize = '16px';
    export let pointer = true;
    export let fontWeight = '400';
</script>

<button
    class="{s.actionButton} {s[color] || ''} {s[template] || ''}"
    class:s.pointer={pointer}
    style="margin-bottom: {marginBottom}; margin-top: {marginTop}; font-size: {fontSize}; line-height: {lineHeight}; font-weight: {fontWeight}"
    type="button"
    on:click={handleClick}
>
    {children}
</button>
